import Axios from 'axios'
import notify from 'devextreme/ui/notify'
import DXSTORE from 'devextreme/data/custom_store'
import store from '@/store/store'

const URL = 'api/system/order'

function isNotEmpty(value) {
    return value !== undefined && value !== null && value !== '';
}

const $Store = new DXSTORE({
    key: 'id',
    load: function (loadOptions) {

        let params = '?';
        [
            'skip',
            'take',
            'requireTotalCount',
            'requireGroupCount',
            'sort',
            'filter',
            'totalSummary',
            'group',
            'groupSummary'
        ].forEach(function (i) {
            if (i in loadOptions && isNotEmpty(loadOptions[i])) { params += `${i}=${JSON.stringify(loadOptions[i])}&`; }
        });

        debugger;
        params = params.slice(0, -1);
        var str = store;
        debugger
        // var open = str.getters["orders/filters"] ? '?filter="open"' : ''
        var filter = str.getters["orders/filters"];

        filter = filter.length > 0 ? '?filter=' + filter : filter;

        return Axios.get(URL + filter + params)
            .then(response => {
                if (response.data.success) {
                    var rsp = {
                        data: response.data.msg.data,
                        totalCount: response.data.msg.totalCount,
                    }

                    debugger;
                    return rsp
                } else {
                    notify(response.data.msg, 'error', 4000)
                    return { data: [], totalCount: 0 }
                }
            })
            .catch(err => {
                notify('Can\'t load users right now, ' + err.message, 'error')
                str.dispatch('updateStat', false)
            })

    }
})

export default {
    namespaced: true,
    state: {
        orders: [],
        filters: 'Open',
        dxOrderStore: $Store
    },
    mutations: {
        setOrders(state, ords) {
            state.orders = ords ? ords : [];
        },
        setFilter(state, stat) {
            stat = stat === null ? false : stat;

            state.filters = stat;
        }
    },
    actions: {
        filters({ commit }, stat) {
            debugger;
            stat = stat === null ? false : stat;

            commit('setFilter', stat);
            return;
        },
        async getOrders({ commit, state }) {

            var url = URL + state.filters ? "open" : "";

            return Axios.get(URL)
                .then(response => {
                    commit('setOrders', response.data);
                })
                .catch(err => notify(err.message, 'error'))
        },
        async getOrder({ commit }, id) {
            return Axios.get(URL + '?id=' + id)
                .then(rsp => {
                    return rsp.data.msg;
                })
                .catch(err => notify(err.message, 'error', 4000))
        },
        async updateOrder({ commit }, ord) {
            return Axios.put(URL + '?id=' + ord.id, ord)
                .then(response => {
                    var type = response.data.success ? 'success' : 'error'

                    // return this.dispatch('sysOrdes/getOrders')
                    //     .then(response => {
                    notify(response.data.msg, 'success', 4000)
                    return response.data.success;
                    // })
                    //.catch(err => notify(err.message, 'error'))
                })
                .catch(err => {

                    notify(err.message, 'error')
                    return false;
                })
        },
        async addOrder({ commit, state }, ord) {
            return Axios.post(URL, ord)
                .then(response => {
                    var data = response.data;
                    debugger;
                    var type = data.success ? 'success' : 'error'

                    if (data.success) {
                        debugger;

                        notify(data.msg, type, 4000);
                        // var order = state.orders.find(o => o.number === null);

                        // order.number = data.msg.number;
                        // order.updated_at = data.msg.updated_at;
                        // order.created_at = data.msg.created_at;
                        // order.order_items.clear();

                        // data.msg.order_items.forEach(i => order.order_items.push(i));

                        return data.success;
                    } else {

                        notify(response.data.msg, type, 4000)
                        return false;
                    }

                    // return this.dispatch('sysOrdes/getOrders')
                    //     .then(response => {
                    // })
                    //.catch(err => notify(err.message, 'error'))
                })
                .catch(err => {
                    notify(err.message, 'error')
                    return false;
                })
        },
        async deleteOrder({ commit }, id) {
            return Axios.delete(URL + '?id=' + id)
                .then(rsp => {
                    var type = rsp.data.success ? 'success' : 'error';

                    notify(rsp.data.msg, type, 4000);
                    return rsp.data.success;
                })
                .catch(err => {
                    notify(err.message, 'error', 4000)
                    return false;
                })
        },
        async itemDupCheck({ commit }, details) {
            debugger;
            if (details.order_items.length === 0) {
                return true;
            }

            return Axios.put('api/system/itemdup?siteId=' + details.site_id, details.order_items)
                .then(rsp => {
                    debugger
                    var success = rsp.data.success;
                    var rItems = rsp.data.msg;

                    if (success) {
                        //Update items with response:
                        details.order_items.forEach(i => {
                            var itm = rItems.find(ix => ix.item_id === i.item_id)

                            if (itm) {
                                i.inExistingOrder = itm.inExistingOrder
                            }
                        })

                        return true
                    } else {

                        return true

                    }

                })
                .catch(err => {
                    notify(err.message, 'error', 4000)
                    return false;
                })
        },
        async ackOrder({ commit }, tk) {
            if (!tk) {
                notify('Invalid or null token, cannot proceed!', 'error', 4000);
                return false;
            }

            return Axios.patch('api/system/ordack?tk=' + tk)
                .then(r => {
                    // var type = r.data.success ? 'success' : 'error';
                    debugger;
                    return r.data;
                })
                .catch(err => {
                    notify(err.message, 'error', 4000);
                    return false;
                })
        }
    },
    getters: {
        filters: state => state.filters,
        orders: state => state.orders,
        store: state => state.dxOrderStore,
        orderItems: (state) => (orderId) => Axios.get('api/system/order-items?id=' + orderId)
            .then(response => response.data)
            .catch(err => notify(err.message, 'error'))
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/admin/LinkDSG/dsgOrders.js